import http from "../base";
import {
  FRENDSHIP_CREATE,
  COMMENT_OFFENSIVE,
  MEDIA_COMMENT,
  MEDIA_LIKE
} from "../constants/path";
import {
  INS_API_FOLLOW_USER,
  INS_API_COMMENT_MEDIA_CHECK_OFFENSIVE,
  INS_API_COMMENT_MEDIA_COMMENT,
  INS_API_LIKE_MEDIA
} from "../constants/event_consts";
import PresisiteAPIParams from "../persisits/lunch_params";
import { cg_api_signed_body, creatUUid } from "../utils";
/**
 * follow user
 * @param userId
 * @param targetId
 * @returns
 */
export const friendshipsCreate = async (
  userId: string,
  targetId: string
): Promise<void> => {
  const body: Record<string, string> = {};
  body.user_id = targetId;
  body._uid = userId;
  body._uuid = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  body.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  body.container_module = "profile";
  const navChain =
    "IGMainAppViewController:explore_popular:1,IGExploreViewController:explore_popular:3,IGSearchResultsTabViewController:search_users:5,IGMainAppViewController:profile:1,IGExploreViewController:explore_popular:3,IGProfileViewController:profile:6";
  body.nav_chain = navChain;

  try {
    return await http.post(
      FRENDSHIP_CREATE(targetId),
      {
        headers: {
          "X-IG-Nav-Chain": navChain
        },
        data: cg_api_signed_body(body)
      },
      {
        user_id: userId
      },
      INS_API_FOLLOW_USER
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const mediaLike = async (userId: string, mediaId: string) => {
  const params: Record<string, string> = {};
  params.d = "0";
  const body: Record<string, string> = {};
  body.media_id = mediaId;
  body._uid = userId;
  body._uuid = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  body.device_id = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  body.delivery_class = "organic";
  body.is_carousel_bumped_post = "false";
  body.container_module = "feed_contextual_profile";
  body.module_name = "feed_contextual_post";
  body.carousel_index = "0";
  body.source_of_like = "button";
  const navChain =
    "IGMainAppViewController:explore_popular:1,IGExploreViewController:explore_popular:3,IGSearchResultsTabViewController:search_users:5,IGMainAppViewController:feed_contextual_profile:1,IGExploreViewController:explore_popular:3,IGProfileViewController:profile:6,IGContextualFeedViewController:feed_contextual_profile:7";
  body.nav_chain = navChain;

  try {
    const result = await http.post(
      MEDIA_LIKE(mediaId),
      {
        data: cg_api_signed_body(body),
        params
      },
      {
        user_id: userId
      },
      INS_API_LIKE_MEDIA
    );
    console.log("mediaLike result", result);
    return result;
  } catch (error) {
    return Promise.reject(error);
  }
};

/**
 * 发布评论，先调用media offensive，再调用mediaComment
 * @param mediaId
 * @param commentText
 * @returns
 */

export const mediaCommentOffensive = async (
  mediaId: string,
  commentText: string,
  userId: string
) => {
  const checkBody: Record<string, string> = {};
  checkBody.media_id = mediaId;
  checkBody.comment_text = commentText;
  checkBody._uuid = await PresisiteAPIParams.getAPIId("cg_api_device_id");
  checkBody._uid = userId;
  checkBody.comment_session_id = creatUUid()
    .replace("_", "")
    .toLowerCase();
  const navChain =
    "IGExploreViewController:explore_popular:2:main_explore,IGSearchContainerViewController:search:3:,IGPageViewController:page_view:4:,IGSearchResultsTabViewController:blended_search:5:,IGSearchResultsTabViewController:search_users:6:,IGProfileViewController:profile:7:,IGContextualFeedViewController:feed_contextual_profile:8:,IGCommentThreadV2ViewController:comments_v2_feed_contextual_profile:9:media_comments";

  try {
    const offensive = await http.post(
      COMMENT_OFFENSIVE,
      {
        data: cg_api_signed_body(checkBody),
        headers: {
          "X-IG-Nav-Chain": navChain
        }
      },
      { user_id: userId },
      INS_API_COMMENT_MEDIA_CHECK_OFFENSIVE
    );
    return offensive;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const mediaComment = async (
  offensive: any,
  commentText: string,
  mediaId: string,
  userId: string
) => {
  try {
    const is_offensive = offensive.is_offensive;
    if (typeof is_offensive !== "boolean") {
      return Promise.reject({
        error_type: "data_is_offensive_invalid",
        code: -1,
        message: "data.is_offensive is not a boolean"
      });
    }
    if (is_offensive) {
      return Promise.reject({
        error_type: "data_is_offensive_invalid",
        message: "This comment is offensive",
        code: -1
      });
    }
    const navChain =
      "IGExploreViewController:explore_popular:2:main_explore,IGSearchContainerViewController:search:3:,IGPageViewController:page_view:4:,IGSearchResultsTabViewController:blended_search:5:,IGSearchResultsTabViewController:search_users:6:,IGProfileViewController:profile:7:,IGContextualFeedViewController:feed_contextual_profile:8:,IGCommentThreadV2ViewController:comments_v2_feed_contextual_profile:9:media_comments";

    const commentBody: Record<string, string> = {};
    commentBody.comment_text = commentText;
    commentBody._uuid = await PresisiteAPIParams.getAPIId("cg_api_device_id");
    commentBody._uid = userId;
    commentBody.nav_chain = navChain;
    commentBody.delivery_class = "organic";
    commentBody.is_carousel_bumped_post = "false";
    commentBody.container_module = "comments_v2_feed_contextual_chain";
    commentBody.idempotence_token = await PresisiteAPIParams.getAPIId(
      "cg_api_device_id"
    );
    commentBody.carousel_index = "0";

    return await http.post(
      MEDIA_COMMENT(mediaId),
      {
        data: cg_api_signed_body(commentBody),
        headers: {
          "X-IG-Nav-Chain": navChain
        }
      },
      { user_id: userId },
      INS_API_COMMENT_MEDIA_COMMENT
    );
  } catch (error) {
    return Promise.reject(error);
  }
};
